module.exports = __webpack_public_path__ + "static/media/39.2b79edd5.jpeg";